<mat-toolbar color="accent">Attach ACC Documents</mat-toolbar>

<div class="flex flex-col gap-6 p-4">
  <pr-information-box>
    Use this form to provide details for a specific category of documents. Files
    for this category will be uploaded in the next step.
  </pr-information-box>

  <form class="flex flex-col items-center" [formGroup]="form">
    <div class="flex w-full items-center gap-2">
      <mat-form-field class="flex-1">
        <mat-label>Document/s Content Type</mat-label>
        <mat-select formControlName="contentType">
          @for (option of contentTypeOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label>Claim Reference Number</mat-label>
        <input matInput formControlName="claimReferenceNumber" />
      </mat-form-field>
    </div>

    <div class="flex w-full items-center gap-2">
      <mat-form-field class="flex-1">
        <mat-label>Patient First Name</mat-label>
        <input matInput formControlName="clientFirstName" />
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label>Patient Last Name</mat-label>
        <input matInput formControlName="clientLastName" />
      </mat-form-field>
    </div>

    <div class="flex w-full items-center gap-2">
      <mat-form-field class="flex-1">
        <mat-label>Patient NHI Number</mat-label>
        <input matInput formControlName="clientNHINumber" />
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label>Patient Date of Birth</mat-label>
        <input
          matInput
          formControlName="clientDOB"
          [matDatepicker]="clientDOB"
          [required]="true"
          (focus)="clientDOB.open()"
          (click)="clientDOB.open()"
        />
        <mat-datepicker-toggle matIconSuffix [for]="clientDOB" />
        <mat-datepicker #clientDOB />
      </mat-form-field>
    </div>

    <pt-buttons-container class="self-end">
      <button mat-flat-button color="primary" (click)="submit()">
        Upload Documents
      </button>
    </pt-buttons-container>
  </form>
</div>
